import {
  faMapMarkerAlt,
  faStar,
  faShare,
  faHeart,
} from "@fortawesome/free-solid-svg-icons"
import {
  faHeart as farHeart,
  faShareSquare as farShareSquare,
} from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Link from "next/link"
import { forwardRef } from "react"
import styled from "styled-components"

import { Photo } from "../../components/media/Photo"
import { Tags } from "../../components/Tags"
import { useRouter } from "next/router"
import { useState } from "react"
import faker from "faker"
import { VenueBookmarkIcon } from "./widgets/VenueBookmarkIcon"

export const VenueTileStyled = styled.a<any>`
  flex-direction: column;
  grid-column: span 12 / auto !important;
  min-width: 0px !important;
  height: initial;
  margin: 0 !important;
  border-bottom: 1px solid #e8e8e8;

  > .photos {
    margin-right: 0 !important;
    padding: 0 !important;
    margin-bottom: 8px;
  }

  > .photoWrapper {
    width: 100% !important;
    // height: 220px !important;
  }

  &:hover {
    // background-color: #fafafa;
  }

  @media (min-width: 1324px) {
    flex-direction: row !important;
    .photos {
      width: 300px;
      padding: 0 !important;
    }
  }

  @media (min-width: 600px) {
    flex-direction: column;
    height: 250px;
    min-height: 250px;
    cursor: pointer;
    max-height: 250px;

    display: inline-block;
    color: initial;
    background-color: white;

    display: flex;
    flex-direction: row;
    text-decoration: none !important;

    grid-column: span 12 / auto !important;
    min-width: 0px !important;
    height: initial;

    .photos {
      min-height: 100px;
      margin-right: 24px;
    }

    .photoWrapper {
      height: 200px;
      background-color: #f0f0f0;
      overflow: hidden;
    }

    margin-bottom: 20px;
    .photos {
      width: 300px;
      padding: 0 !important;
    }
  }

  ${(props) =>
    props.horizontal &&
    `
    background-color: yellow;
    flex-direction: row;
    margin:  0 !important;
    max-height: 100%;
    display: flex;
    flex-direction: row;
    
    @media (min-width: 600px) {
      .photos {
        width: 120px;
        height: 120px !important;
        min-height: 120px !important;
        
        .photoWrapper {
          height: 100%;
        }
      }
    }
  `}
`

const VenueTileContent = styled.div`
  background-color: white;
  border-radius: 8px;
  width: 100%;
  text-overflow: ellipsis;
  display: flex;
  flex-direction: column-reverse;

  @media (min-width: 600px) {
    justify-content: space-between;
    padding: 20px 16px;
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: column;

    > .topRow {
      margin-bottom: 20px;

      > .name {
        font-weight: normal;
        text-decoration: none;
        font-size: 18px;
        line-height: 20px;
        text-overflow: ellipsis;
        font-weight: 900;
        flex: 1;
      }

      > .score {
        font-size: 24px;
        line-height: 24px;
        display: flex;

        > .icon {
          font-size: 18px;
          margin-right: 6px;
          width: 24px;
          height: 24px;
          display: flex;
          color: var(--moje-color-pink);
        }
        > .value {
          font-weight: 900;
          font-size: 18px;
          line-height: 20px;
        }
      }
    }

    > .tagsContainer {
      margin-bottom: 6px;

      > * {
        margin-right: 4px;
      }

      > *:last-child: {
        margin-right: 0px;
      }
    }

    > .description {
      flex: 1;
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      max-height: 120px;
      // height: 120px;
      padding-bottom: 6px;
    }

    > .offer {
      display: flex;
      flex-direction: row;
      font-size: 16px;
      justify-content: flex-start;
    }

    > .footer {
      color: #333;
      display: flex;
      flex-direction: row;
      line-height: 2;

      svg {
        color: #aaa;
      }

      > .separator {
        border-left: 1px solid #ccc;
        margin: 0 6px;
      }
    }

    ${(props) =>
      props.horizontal &&
      `
        padding: 4px;
        max-height: 100%;
        .tagsContainer {
          display: none;
        }
    `}
  }
`

const PhotoContainer = styled.div`
  height: 188px;
  margin-bottom: 12px;

  @media (min-width: 600px) {
    height: unset;
    margin-bottom: 0;
  }
`

const TitleContainer = styled.div`
  max-width: 100%;

  @media (min-width: 600px) {
    max-width: 80%;
  }
`

export const VenueTile: any = forwardRef<any>((props: any, ref) => {
  const { venue, onMouseOverVenue, onMouseLeaveVenue, selected, searchResult } =
    props

  // const price: number = 452.21;
  // const tags: string[] = ['Sale Zabaw', 'Baseny', 'Trampoliny', 'Escape Room'];
  // const rating: number = 4.5;
  // const recentRatings: number = 1256;
  // const isLiked: boolean = false;

  const tagsSample = [
    "Sale Zabaw",
    "Baseny",
    "Trampoliny",
    "Escape Room",
    "Online",
  ]

  const tags: string[] = faker.random.arrayElements(tagsSample, 3)
  const rating: number = faker.datatype.number(5.0)
  const recentRatings: number = faker.datatype.number(5000)
  const isLiked: boolean = faker.datatype.boolean()

  const [isLoading, setIsLoading] = useState(false)

  const router = useRouter()

  const handleVenue = async (e, href) => {
    e.preventDefault()
    const response = await router.push(href)
  }

  return (
    <Link href={`/miejsce/${venue?.slug ?? venue?.id}`} passHref>
      <VenueTileStyled
        horizontal={props.horizontal}
        ref={ref}
        onMouseEnter={() =>
          onMouseOverVenue ? onMouseOverVenue(venue) : undefined
        }
        onMouseLeave={() =>
          onMouseLeaveVenue ? onMouseLeaveVenue(venue) : undefined
        }
      >
        {/* <a> */}
        <PhotoContainer className="flex flex-1 sm:p-4 relative">
          <div className="sm:hidden flex-row flex absolute z-10 top-2 justify-between w-full px-2">
            <div>
              <div className="flex flex-row flex-wrap">
                <Tags label={tags[0]} className="bg-white" />
              </div>
            </div>
            <div className="flex-row flex items-center">
              <div
                style={{ width: 28, height: 28 }}
                className="flex rounded-full justify-center items-center p-2 mr-1 bg-white "
              >
                <FontAwesomeIcon icon={farShareSquare} />
              </div>
              {/* We will bring this back when ready, don't remove */}
              <div
                style={{ width: 28, height: 28 }}
                className={`flex rounded-full justify-center items-center p-2 ${
                  isLiked ? "bg-themePink" : "bg-white"
                }`}
              >
                <VenueBookmarkIcon venue={venue} />
              </div>
            </div>
          </div>
          <div className="flex flex-1 items-center rounded-2xl overflow-hidden">
            {venue.media && venue.media.length > 0 ? (
              <Photo media={venue.media[0]} imgWidth={600} />
            ) : (
              <div style={{ backgroundColor: "black", height: "100%" }}></div>
            )}
          </div>
        </PhotoContainer>
        <VenueTileContent horizontal={props.horizontal}>
          <div>
            <div className="topRow flex flex-row justify-between pb-2 sm:pb-0">
              <TitleContainer>
                <div className="font-medium font-poppins text-base sm:text-xl">
                  {venue.name}
                </div>

                {venue.city && (
                  <div
                    className="text-sm sm:text-base text-gray-600 font-light"
                    title={venue.distance}
                  >
                    {venue.city} {venue.address}
                  </div>
                )}
                {venue?.category?.name && (
                  <div className="tagsContainer sm:flex hidden flex-row flex-wrap mt-1">
                    <Tags label={venue.category.name} className="mr-1" />
                  </div>
                )}
              </TitleContainer>

              {venue.minPrice && venue.minPrice != 0 && (
                <div className="sm:block hidden font-poppins font-semibold text-themeOrange">
                  {venue.minPrice || 0} zł
                </div>
              )}
            </div>

            {/* <div className="description">
              {venue.shortDescription && <div>{venue.shortDescription}</div>}
            </div> */}

            {/* Keep tags hidden now */}
            {/* {venue.category && <div className="tagsContainer sm:flex hidden flex-row flex-wrap mt-4">
              {tags.map((tag: string) => {
                return <Tags label={tag} className="mr-1" />
              })}
            </div> */}
          </div>

          <div className="flex flex-row justify-between">
            <div className="flex flex-row items-center">
              {/* We will bring this back when ready, don't remove */}
              {/* <FontAwesomeIcon
                icon={faStar}
                style={{ color: "#FDC600", marginRight: 4, paddingBottom: 2 }}
              />
           
              <p className="text-black font-poppins font-medium text-base mr-1">
                {rating}
              </p>
              <p className="font-normal text-xs">
                ({recentRatings} recenzji)
              </p> */}
            </div>

            <div className="sm:hidden flex">
              <div className="font-poppins font-semibold text-themeOrange text-xl">
                {venue.minPrice || 0} zł
              </div>
            </div>

            <div className="sm:flex flex-row hidden">
              {/* <div className="flex rounded-full border border-borderGray justify-center items-center p-2 mr-1">
                <FontAwesomeIcon icon={farShareSquare} />
              </div> */}
              {/* We will bring this back when ready, don't remove */}
              {/* <div
                className={`flex rounded-full border border-borderGray justify-center items-center p-2 ${
                  isLiked ? "bg-themePink" : ""
                }`}
              >
              */}
              <VenueBookmarkIcon venue={venue} />
            </div>
          </div>

          {/* <div className="offer">
            <div style={{ paddingRight: 5 }}>od</div>
            <strong>150 zł</strong>
            <div style={{ paddingLeft: 5 }}>{" / 2 godziny"}</div>
          </div> */}

          {/* <div className="footer">
            {venue.address && (
              <>
                <FontAwesomeIcon
                  icon={faMapMarkerAlt}
                  style={{ width: 10, paddingRight: 6 }}
                />
                <div>{venue.address}</div>
              </>
            )}
            {searchResult && searchResult.distance && (
              <>
                <div className="separator" />
                {Number(searchResult.distance).toFixed(0) + "m "}
              </>
            )}
            {venue.products && (
              <>
                {venue.address && <div className="separator" />}
                <div>{venue.products.length.toString()} scenariusze zabaw</div>
              </>
            )}
          </div> */}
          {/* {venue.distance && venue.distance != -1 && (
            <div>
              <div> Odległość {venue.distance.toFixed(3)} </div>
            </div>
          )} */}
        </VenueTileContent>
        {/* </a> */}
      </VenueTileStyled>
    </Link>
  )
})
